var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("h4", { staticClass: "card-title" }, [
              _vm._v("Resultado da pesquisa")
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { cursor: "pointer" },
                    attrs: { data: _vm.dados }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "Ordem de Serviço",
                        "min-width": "250",
                        prop: "numeroOS"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Processos pendentes",
                        "min-width": "100",
                        prop: "totalProcessosPendentes",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Processos tramitados",
                        "min-width": "100",
                        prop: "totalProcessosTramitados",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Total",
                        "min-width": "100",
                        prop: "totalProcessos",
                        align: "center"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae6de4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae6de4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/os/TabelaOS.vue
// module id = null
// module chunks = 